var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSeatIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.0744 32.3833L33.5744 32.3833L33.5744 31.8833L33.5744 5.14404C33.5744 2.65876 31.5597 0.644044 29.0744 0.644044L8.69971 0.644043C6.21443 0.644043 4.19971 2.65877 4.19971 5.14405L4.19971 31.8833L4.19971 32.3833L4.69971 32.3833L33.0744 32.3833Z",
    fill: "#1EAF28",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.00049 17.2282C2.00049 15.5249 3.38134 14.144 5.0847 14.144C6.78806 14.144 8.16891 15.5249 8.16891 17.2283L8.1689 32.8549L6.00049 32.8549C3.79135 32.8549 2.00049 31.0641 2.00049 28.8549L2.00049 17.2282Z",
    fill: "#1EAF28",
    stroke: "white",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0005 18.2282C30.0005 16.5249 31.3813 15.144 33.0847 15.144C34.7881 15.144 36.1689 16.5249 36.1689 18.2283L36.1689 29.8549C36.1689 32.0641 34.378 33.8549 32.1689 33.8549L30.0005 33.8549L30.0005 18.2282Z",
    fill: "#1EAF28",
    stroke: "white",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0088 30.9203L38.0088 35.2065C38.0088 37.4157 36.2179 39.2065 34.0088 39.2065L5.54932 39.2065C3.34018 39.2065 1.54932 37.4157 1.54932 35.2065L1.54932 30.9203L38.0088 30.9203Z",
    fill: "#1EAF28",
    stroke: "white",
    strokeWidth: 3
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeatIcon);
export default __webpack_public_path__ + "static/media/seatIcon.a5ee2def15db80db8ca953a7b30ff976.svg";
export { ForwardRef as ReactComponent };